import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  ListItem,
  OrderedList,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import React from "react";

function PrivacyPage() {
  return (
    <>
      <Box p={8}>
        <Heading as="h1" size="xl" mb={4}>
          TenK Solutions, LLC
        </Heading>
        <Accordion defaultIndex={[0]} allowMultiple>
          <AccordionItem>
            <AccordionButton>
              <Box flex="1" textAlign="left">
                <Heading as="h2" size="lg">
                  Privacy Policy
                </Heading>
                <Text fontSize="sm" color="gray.500">
                  Last updated: 05/29/2023
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4}>
              {/* Privacy Policy content goes here */}
              <Text mb={"3"}>
                This Privacy Policy outlines how TenK Solutions, LLC collects,
                uses, and protects the personal information provided by users
                ("you" or "users") of our website and services. We are committed
                to safeguarding your privacy and ensuring the security of your
                personal information. By using our website and services, you
                consent to the terms of this Privacy Policy.
              </Text>
              <OrderedList spacing={4}>
                <ListItem>
                  Information We Collect:
                  <UnorderedList>
                    <ListItem>
                      Personal information (such as name, email address, contact
                      details) provided voluntarily by users.
                    </ListItem>
                    <ListItem>
                      Non-personal information (such as IP addresses, browser
                      information, device details) collected automatically
                      through cookies and similar technologies.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  Use of Information:
                  <UnorderedList>
                    <ListItem>
                      Personal information is used to communicate with you,
                      provide requested services, and improve user experience.
                    </ListItem>
                    <ListItem>
                      Non-personal information is used for website analytics,
                      marketing purposes, and enhancing our services.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  Data Security:
                  <UnorderedList>
                    <ListItem>
                      We implement industry-standard security measures to
                      protect your personal information from unauthorized
                      access, loss, or misuse.
                    </ListItem>
                    <ListItem>
                      However, no data transmission over the internet or
                      electronic storage is completely secure, and we cannot
                      guarantee absolute security.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  Third-Party Disclosure:
                  <UnorderedList>
                    <ListItem>
                      We do not sell, trade, or transfer your personal
                      information to outside parties without your consent,
                      except as required by law or to provide requested
                      services.
                    </ListItem>
                    <ListItem>
                      We may share non-personal information with trusted
                      third-party service providers who assist us in operating
                      our website and services.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  Cookies and Tracking Technologies:
                  <UnorderedList>
                    <ListItem>
                      Our website may use cookies and similar technologies to
                      enhance user experience, analyze website traffic, and
                      personalize content.
                    </ListItem>
                    <ListItem>
                      You can adjust your browser settings to manage cookies or
                      opt-out of certain tracking technologies, although this
                      may affect website functionality.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
              </OrderedList>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <AccordionButton>
              <Box flex="1" textAlign="left">
                <Heading as="h2" size="lg">
                  Terms of Service
                </Heading>
                <Text fontSize="sm" color="gray.500">
                  Last updated: 05/29/2023
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4}>
              {/* Terms of Service content goes here */}
              <Text mb={3}>
                These Terms of Service ("Terms") govern the use of TenK
                Solutions, LLC's website and services. By accessing or using our
                website and services, you agree to comply with these Terms. If
                you do not agree with any part of these Terms, please refrain
                from using our website and services.
              </Text>
              <OrderedList spacing={4}>
                <ListItem>
                  Intellectual Property:
                  <UnorderedList>
                    <ListItem>
                      All content on our website, including text, graphics,
                      logos, and images, is protected by intellectual property
                      laws and is the property of TenK Solutions, LLC or its
                      licensors.
                    </ListItem>
                    <ListItem>
                      You may not reproduce, distribute, modify, or create
                      derivative works from any content without explicit
                      permission.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  User Responsibilities:
                  <UnorderedList>
                    <ListItem>
                      You are responsible for maintaining the confidentiality of
                      your account credentials and for all activities conducted
                      under your account.
                    </ListItem>
                    <ListItem>
                      You agree to use our website and services in compliance
                      with applicable laws and regulations and refrain from
                      engaging in any illegal or unauthorized activities.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  Limitations of Liability:
                  <UnorderedList>
                    <ListItem>
                      TenK Solutions, LLC shall not be held liable for any
                      damages or losses arising from the use or inability to use
                      our website and services.
                    </ListItem>
                    <ListItem>
                      We do not guarantee the accuracy, completeness, or
                      timeliness of the content on our website.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  Third-Party Links:
                  <UnorderedList>
                    <ListItem>
                      Our website may contain links to third-party websites or
                      resources that are not controlled or endorsed by TenK
                      Solutions, LLC.
                    </ListItem>
                    <ListItem>
                      We are not responsible for the content or practices of any
                      third-party websites, and your use of such websites is at
                      your own risk.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
                <ListItem>
                  Modification of Terms:
                  <UnorderedList>
                    <ListItem>
                      TenK Solutions, LLC reserves the right to modify or update
                      these Terms at any time without prior notice.
                    </ListItem>
                    <ListItem>
                      Continued use of our website and services after any
                      modifications to the Terms constitutes acceptance of the
                      updated Terms.
                    </ListItem>
                  </UnorderedList>
                </ListItem>
              </OrderedList>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
        <Text mt={"6"}>
          Please review our full Privacy Policy and Terms of Service for a
          complete understanding of how we handle your personal information and
          the terms governing your use of our website and services. If you have
          any questions or concerns, please contact us at
          hello@tenksolutions.com.
          
        </Text>
      </Box>
    </>
  );
}
export default PrivacyPage;
